<script>
    import moment from 'moment';

    let year = moment().format('YYYY');
</script>

<div class="w-100 text-center padding-16">{year} &copy; Guglielmo <i>v0.0.0.1</i></div>
